"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var react_redux_1 = require("react-redux");
var lab_1 = require("@material-ui/lab/");
var __1 = require("../..");
var actions_1 = __importDefault(require("../../../../actions"));
var LinkHistoryPagination_1 = __importDefault(require("./LinkHistoryPagination"));
var LinkHistoryItem_1 = __importDefault(require("./LinkHistoryItem"));
var useStyles = core_1.makeStyles(function () {
    return core_1.createStyles({
        rootTimeline: {
            marginLeft: 0,
            marginRight: 15,
            paddingLeft: 0,
        },
    });
});
function LinkHistory() {
    var classes = useStyles();
    var ITEMS_PER_PAGE = 10;
    var _a = __read(react_1.default.useState(0), 2), currentPage = _a[0], setCurrentPage = _a[1];
    // Handles redux state for link history
    var dispatch = react_redux_1.useDispatch();
    var shortUrl = __1.useDrawerState().relevantShortLink || '';
    var _b = react_redux_1.useSelector(function (state) { return state.user; }), linkHistory = _b.linkHistory, linkHistoryCount = _b.linkHistoryCount;
    var changeSetLen = linkHistory.length;
    var getLinkHistoryForUser = function () {
        var offset = currentPage * ITEMS_PER_PAGE;
        dispatch(actions_1.default.getLinkHistoryForUser(shortUrl, offset, ITEMS_PER_PAGE));
    };
    react_1.useEffect(function () {
        getLinkHistoryForUser();
    }, [currentPage]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(lab_1.Timeline, { className: classes.rootTimeline }, linkHistory &&
            linkHistory.map(function (currSet, idx) {
                return (react_1.default.createElement(LinkHistoryItem_1.default, { key: "LinkHistoryItem-" + currSet.updatedAt, changeSet: currSet, 
                    // Remove bottom connector for the bottom item
                    removeBottomConnector: idx === changeSetLen - 1 }));
            })),
        react_1.default.createElement(LinkHistoryPagination_1.default, { page: currentPage, pageCount: Math.ceil(linkHistoryCount / ITEMS_PER_PAGE), onChangePage: setCurrentPage })));
}
exports.default = LinkHistory;
